import * as React from 'react';
import { Flex, Box } from 'rebass';
import { Heading } from '../';
export default React.memo(function Titlebar(_a) {
    var content = _a.content, leftContent = _a.leftContent, centreContent = _a.centreContent, rightContent = _a.rightContent, title = _a.title;
    return (React.createElement(Flex, { sx: { height: function (theme) { return theme.space[10]; } }, "data-qa": "title-bar_div", alignItems: "center", justifyContent: "space-between" },
        leftContent && React.createElement(Box, { flex: "0 1 auto" }, leftContent),
        React.createElement(Box, { p: 4 },
            React.createElement(Heading, { variant: "h3" }, title)),
        content && (React.createElement(Box, { flex: "1 1", alignSelf: "stretch" }, content)),
        !content && (React.createElement(React.Fragment, null,
            centreContent && React.createElement(Flex, { height: "100%" }, centreContent),
            rightContent && React.createElement(Flex, { alignItems: "right" }, rightContent)))));
});
